import { SyncApi } from '../apis';
import BaseStore from './BaseStore';
import { flow, makeObservable, observable } from 'mobx';

export default class SyncStore extends BaseStore {

    constructor(rootStore) {
        super(rootStore);
        makeObservable(this, {
            checkUserByEmail: flow.bound,
            createUserByEmail: flow.bound,
            getStdEiInfo: flow.bound,
            syncAndCreateWithEi: flow.bound,
        });
        this.rootStore = rootStore;
        this.api = new SyncApi();
    }

    *checkUserByEmail(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.checkUserByEmail,
                payload
            );
            if (res.ok) {
                return res?.data || true;
            }
            return false;
        } catch (error) {
            console.warn(error);
        }
    }

    *createUserByEmail() {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.createUserByEmail
            );
            if (res.ok) {
                return true;
            }
            return false;
        } catch (error) {
            console.warn(error);
        }
    }

    *getStdEiInfo(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getStdEiInfo,
                payload
            );
            if (res.ok) {
                return res.data;
            }
            return false;
        } catch (error) {
            console.warn(error);
        }
    }

    *syncAndCreateWithEi(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api,
                this.api.syncAndCreateWithEi,
                payload
            );
            if (res.ok) {
                return true;
            }
            return false;
        } catch (error) {
            console.warn(error);
        }
    }

    clean() {
        super.clean();
    }
}
